import React from 'react';
import '../css/AboutSection.css';
import backgroundImage from '../assets/about-us-background.webp';
import { Users, Award, Smile, Lightbulb, Handshake, Gift, Target } from 'lucide-react';
import OurPeople from './OurPeople';

const AboutSection: React.FC = () => {
  return (
    <>
    <div className="about-section">
      {/* Background Image */}
      <img 
        src={backgroundImage} 
        alt="" 
        className="about-background"
      />
      
      {/* Content */}
      <div className="about-content">
        {/* Header */}
        <div className="about-header">
          <h2 className="about-title">About Crikey<sup>ai</sup></h2>
          <p className="about-description">
            We combine human expertise with Artificial Intelligence to make claims faster, simpler, and more accurate - improving 
            outcomes for families, teams, and insurers alike. Artificial Intelligence removes limitations, scales expertise, and 
            empowers claims teams to help people faster.
          </p>
        </div>

        {/* Mission and What We Do */}
        <div className="about-grid-two">
          <div className="about-card">
            <h3 className="about-card-title">Our mission</h3>
            <p className="about-card-text">
              Helping people and families fallen on hard times get back on their feet quickly.
            </p>
          </div>
          
          <div className="about-card">
            <h3 className="about-card-title">How we do this</h3>
            <p className="about-card-text">
              We build insurance first AI agents that automate data entry, triage and decisioning – reducing processing 
              time by significantly reducing processing time whilst keeping every step auditable.
            </p>
          </div>
        </div>

        {/* Our Values */}
        <div className="values-section">
          <h3 className="values-title">Our values</h3>
          
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <Users size={40} />
              </div>
              <h4 className="value-card-title">People</h4>
              <p className="value-card-text">Hire & retain the best</p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Award size={40} />
              </div>
              <h4 className="value-card-title">Honesty & integrity</h4>
              <p className="value-card-text">Say what we do & do what we say</p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Smile size={40} />
              </div>
              <h4 className="value-card-title">Having fun</h4>
              <p className="value-card-text">Celebrate success</p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Lightbulb size={40} />
              </div>
              <h4 className="value-card-title">Innovation</h4>
              <p className="value-card-text">Continuous improvement</p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Handshake size={40} />
              </div>
              <h4 className="value-card-title">Collaboration</h4>
              <p className="value-card-text">Team work makes the dream work</p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Gift size={40} />
              </div>
              <h4 className="value-card-title">Community</h4>
              <p className="value-card-text">Giving back where it matters</p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Target size={40} />
              </div>
              <h4 className="value-card-title">Customer obsession</h4>
              <p className="value-card-text">True partnership and value delivery</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <OurPeople />
    </>
  );
};

export default AboutSection;
